// source: wisetime/type/data_retention.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.type.DataRetentionPeriod', null, global);
/**
 * @enum {number}
 */
proto.wisetime.type.DataRetentionPeriod = {
  DATA_RETENTION_PERIOD_UNSPECIFIED: 0,
  FOURTEEN_DAYS: 1,
  SEVEN_DAYS: 2,
  TWENTY_ONE_DAYS: 3,
  ONE_MONTH: 4,
  THREE_MONTHS: 5,
  SIX_MONTHS: 6,
  ONE_YEAR: 7,
  TWO_YEARS: 8,
  MAX_ELIGIBLE: 9
};

goog.object.extend(exports, proto.wisetime.type);
